import { z } from 'zod'

export const LEARNING_ACADEMIC_ADMIN_CONTRACT_VERSION = '1.0.0' as const
export const LEARNING_ACADEMIC_ADMIN_SCHEMA_VERSION = 'learning-academic-admin-v1' as const

const itemResponse = z.object({
  contract_version: z.literal(LEARNING_ACADEMIC_ADMIN_CONTRACT_VERSION),
  item: z.record(z.unknown()),
}).strict()
const listResponse = z.object({
  contract_version: z.literal(LEARNING_ACADEMIC_ADMIN_CONTRACT_VERSION),
  items: z.array(z.record(z.unknown())),
  page: z.number().int().positive(),
  limit: z.number().int().positive(),
  total: z.number().int().nonnegative(),
  nextCursor: z.string().nullable(),
}).strict()

export const learningAcademicAdminProgramReadResponseSchema = itemResponse
export const learningAcademicAdminProgramDraftReadResponseSchema = itemResponse
export const learningAcademicAdminProgramDraftWriteResponseSchema = itemResponse
export const learningAcademicAdminProgramValidateResponseSchema = itemResponse
export const learningAcademicAdminProgramPublishResponseSchema = itemResponse
export const learningAcademicAdminProgramRetireResponseSchema = itemResponse
export const learningAcademicAdminAchievementCorrectResponseSchema = itemResponse
export const learningAcademicAdminAchievementWithdrawResponseSchema = itemResponse
export const learningAcademicAdminIssuerListResponseSchema = listResponse
export const learningAcademicAdminIssuerCreateResponseSchema = itemResponse
export const learningAcademicAdminIssuerReadResponseSchema = itemResponse
export const learningAcademicAdminIssuerUpdateResponseSchema = itemResponse
export const learningAcademicAdminIssuerRetireResponseSchema = itemResponse
export const learningAcademicAdminIdentityLinkResponseSchema = itemResponse
export const learningAcademicAdminDeliveryDestinationListResponseSchema = listResponse
export const learningAcademicAdminDeliveryDestinationReadResponseSchema = itemResponse
export const learningAcademicAdminDeliveryDestinationUpsertResponseSchema = itemResponse
export const learningAcademicAdminDeliveryDestinationRevokeResponseSchema = itemResponse
export const learningAcademicAdminAuditListResponseSchema = listResponse

export type LearningAcademicAdminItemResponse = z.infer<typeof itemResponse>
export type LearningAcademicAdminListResponse = z.infer<typeof listResponse>
